import { css, Theme } from "@emotion/react";

export const root = (theme: Theme) =>
    css({
        width: "100%",
        minHeight: "100%",
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        overflow: "hidden",
        padding: "0 40px",
        boxSizing: "border-box",
    });
